import { isE164 } from '@lib/contacts/utils/phone';

export type SignupPhoneOptInValues = {
  phone?: string;
  smsOptIn: boolean;
};

export function requiresSignupPhoneOtp(
  values: SignupPhoneOptInValues
): boolean {
  const phone = values.phone?.trim() ?? '';
  return values.smsOptIn && phone !== '' && isE164(phone);
}
